import { render, staticRenderFns } from "./ModalSelecionarTerritorioVegaSobreposto.vue?vue&type=template&id=72b53f30&scoped=true&lang=pug"
import script from "./ModalSelecionarTerritorioVegaSobreposto.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarTerritorioVegaSobreposto.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarTerritorioVegaSobreposto.vue?vue&type=style&index=0&id=72b53f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b53f30",
  null
  
)

export default component.exports